import axios from "axios";

const api = axios.create({
  baseURL: "https://codesaarthi.online/khatasaarthi/api",
  headers: { "Content-Type": "application/json" },
});

export default api;
